import classNames from 'classnames';
import useStyles from 'isomorphic-style-loader/useStyles';
import type { PropsWithoutRef } from 'react';
import { forwardRef } from 'react';
import type { CheckboxProps, SemanticCOLORS } from 'semantic-ui-react';
import { Checkbox, Form } from 'semantic-ui-react';

// eslint-disable-next-line postcss-modules/no-unused-class
import s from './toggle.scss';

interface ToggleProps extends Omit<CheckboxProps, 'toggle'> {
  checked: boolean;
  color?: SemanticCOLORS | 'white';
  onChange?: (event: unknown, data: CheckboxProps) => void;
}

const createToggleClassname = ({
  checked,
  color = 'teal',
  className,
}: PropsWithoutRef<ToggleProps>) =>
  classNames(
    s.root,
    s.toggle,
    s[color],
    {
      [s.checked]: checked,
    },
    className,
  );

const Toggle = forwardRef<HTMLDivElement, ToggleProps>(
  (props, forwardedRef) => {
    useStyles(s);
    return (
      <Checkbox
        {...props}
        toggle
        className={createToggleClassname(props)}
        ref={forwardedRef}
      />
    );
  },
);
Toggle.displayName = 'Toggle';

export const FormToggle = forwardRef<HTMLInputElement, ToggleProps>(
  (props, forwardedRef) => {
    useStyles(s);
    return (
      <Form.Checkbox
        {...props}
        toggle
        className={createToggleClassname(props)}
        ref={forwardedRef}
      />
    );
  },
);
FormToggle.displayName = 'FormToggle';

export default Toggle;
